export default __webpack_public_path__ + "static/media/Circly_List_Deletion_3.5849e4a7.gif";